import Vue from 'vue'

const BRANDING_LOOKUP = {
    core: {
        color: '#032e59',
        image: 'logo-core-sm.png'
    },
    scorpion: {
        color: '#6c456e',
        image: 'logo-scorpion-sm.png'
    }
}

const THEME_LOOKUP = {
    core: {
        color: '#0A1929'
    },
    scorpion: {
        color: '#412E42'
    },
    light: {
        color: '#BFBFBF'
    },
    dark: {
        color: '#000000'
    }
}

function setTheme(theme) {
    SESSION.branding.color = THEME_LOOKUP[theme].color || '#333333'
}

function setClientAndBranding(client) {
    const branding = BRANDING_LOOKUP[client]

    if (branding) {
        SESSION.branding = { ...branding }
    }

    SESSION.client = client
}

export const SESSION = Vue.observable({
    branding: {
        color: '#333333',
        image: 'logo-caveon-sm.png'
    },
    sites: [],
    setClientAndBranding,
    setTheme
})